import React from "react";
import { FaCreditCard } from "react-icons/fa";

/**
 * One-line footer note replacing the disabled "Card" tab. Sits
 * between the QR toggle and the security footer.
 */
export function ComingSoonFooter() {
  return (
    <div className="pay-coming-soon-footer">
      <FaCreditCard size={12} />
      Card payments coming soon.
    </div>
  );
}
